<template>
  <div>
    <base-header class="header pb-3 py-5 pt-md-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-8 col-md-10">
            <h1 class="text-white">
              Seja bem-vind{{ getArticleGender(user.gender) }},
              {{ user.name ? user.name.split(" ", 1)[0] : "" }} 😁
            </h1>
            <p class="text-white mt-3 mb-5">
              Aqui no PIC - Portal de Inovação Corporativa você fica por dentro
              das atualizações, organiza seus projetos, documentos, agenda e
              muito mais!
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--5">
      <div class="row">
        <div class="col-xl-8 col-lg-8 px-0">
          <div class="col-xl-12 col-lg-12 px-0">
            <new-post
              :profile_picture="profile_picture"
              :user="user"
              @news="loadInitialNews"
              endpoint="colaborador"
            />
          </div>
          <div class="d-md-none col-xl-4 col-lg-4 px-0">
            <div
              class="post-card card shadow vld-parent mb-4 float-center"
              ref="news_table"
            >
              <div class="card-header border-0">
                <h4 class="text-center mb-0">Aniversários</h4>
                <hr class="my-2" />
              </div>

              <div v-if="birthday.today.length" class="">
                <span class="mr-4 ml-4"
                  ><i class="fas fa-calendar-day mr-1"></i> Hoje</span
                >

                <div :key="index" v-for="(b, index) in birthday.today" class="">
                  <div class="mb-3 mr-4 ml-4" ref="publicacao_container">
                    <div class="">
                      <img
                        width="80"
                        height="80"
                        v-if="b.profile_picture"
                        :src="b.profile_picture"
                        class="rounded mr-2 float-left"
                        alt="foto de perfil"
                      />
                      <i
                        v-else
                        class="fas fa-user-circle fa-4x mr-1 float-left"
                      ></i>
                      <p class="text-bold my-1">{{ b.name }}</p>
                      <p class="text-bold my-1">
                        {{ formatDate(b.birth, "DD/MM") }}
                      </p>
                      <p class="text-bold my-1">
                        <i class="fas fa-birthday-cake"></i>
                        {{ getAge(b.birth) }} anos
                      </p>
                    </div>
                    <div class="row mt-0">
                      <div class="col-12">
                        <base-button
                          class="
                            btn btn-white btn-block
                            secondary-button
                            btn-
                            py-1
                          "
                          @click="
                            $router.push(
                              `/colaborador/colaboradores/${b.user_id}/visualizar`
                            )
                          "
                        >
                          Parabenizar colega
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="birthday.thisWeek.length" class="">
                <span class="mr-4 ml-4"
                  ><i class="fas fa-calendar-week mr-1"></i> Essa semana</span
                >

                <div
                  :key="index"
                  v-for="(b, index) in birthday.thisWeek"
                  class=""
                >
                  <div class="mb-3 mr-4 ml-4" ref="publicacao_container">
                    <div class="">
                      <img
                        width="80"
                        height="80"
                        v-if="b.profile_picture"
                        :src="b.profile_picture"
                        class="rounded mr-2 float-left"
                        alt="foto de perfil"
                      />
                      <i
                        v-else
                        class="fas fa-user-circle fa-4x mr-1 float-left"
                      ></i>
                      <p class="text-bold my-1">{{ b.name }}</p>
                      <p class="text-bold my-1">
                        {{ formatDate(b.birth, "DD/MM") }}
                      </p>
                      <p class="text-bold my-1">
                        <i class="fas fa-birthday-cake"></i>
                        {{ getAge(b.birth) }} anos
                      </p>
                    </div>
                    <div class="row mt-0">
                      <div class="col-12">
                        <base-button
                          class="
                            btn btn-white btn-block
                            secondary-button
                            btn-
                            py-1
                          "
                          @click="
                            $router.push(
                              `/colaborador/colaboradores/${b.user_id}/visualizar`
                            )
                          "
                        >
                          Parabenizar colega
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!birthday.thisWeek.length && !birthday.today.length"
                class="row"
              >
                <div class="col-12 text-center mb-3">
                  <badge type="info" class="bg-white">
                    Nenhum aniversário próximo!
                  </badge>
                </div>
              </div>
            </div>
            <div
              class="post-card card shadow vld-parent mb-4 float-center"
              ref="news_table"
            >
              <div class="card-header border-0">
                <h4 class="text-center mb-0">Pesquisas ativas</h4>
                <hr class="my-2" />
                <div v-if="satisfactionSurveys.length" class="">
                  <div
                    :key="index"
                    v-for="(s, index) in satisfactionSurveys"
                    class=""
                  >
                    <div class="mb-3 mr-4 ml-4" ref="publicacao_container">
                      <div class="">
                        <h3 class="font-weight-bold my-1">{{ s.title }}</h3>
                        <p class="text-bold my-1">
                          Disponível até
                          {{ formatDate(s.end_date, "DD/MM/YYYY") }}
                        </p>
                      </div>
                      <div class="row mt-0">
                        <div class="col-12">
                          <base-button
                            v-if="!s.answered"
                            class="btn btn-white btn-block red-button btn- py-1"
                            @click="
                              $router.push(
                                `/colaborador/pesquisas/${s.id}/resposta`
                              )
                            "
                          >
                            <i class="far fa-newspaper"></i> Ainda não
                            respondida
                          </base-button>
                          <base-button
                            v-else
                            class="
                              btn btn-white btn-block
                              green-button
                              btn-
                              py-1
                            "
                            @click="
                              $router.push(
                                `/colaborador/pesquisas/${s.id}/resposta`
                              )
                            "
                          >
                            <i class="fas fa-check"></i> Resposta enviada
                          </base-button>
                        </div>
                      </div>
                    </div>
                    <hr class="my-2" />
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <router-link
                        class="float-right"
                        to="/colaborador/pesquisas"
                        >Ver todas as pesquisas</router-link
                      >
                    </div>
                  </div>
                  <hr class="my-2 mx--4" />
                </div>

                <div v-if="surveys.length" class="">
                  <div :key="index" v-for="(s, index) in surveys" class="">
                    <div class="mb-3 mr-4 ml-4" ref="publicacao_container">
                      <div class="">
                        <h3 class="font-weight-bold my-1">{{ s.title }}</h3>
                        <p v-if="s.start_date" class="text-bold my-1">
                          Aceitando respostas desde
                          {{ formatDate(s.start_date, "DD/MM/YYYY") }}
                        </p>
                        <p v-if="s.end_date" class="text-bold my-1">
                          Disponível até
                          {{ formatDate(s.end_date, "DD/MM/YYYY") }}
                        </p>
                      </div>
                      <div class="row mt-0">
                        <div class="col-12">
                          <div v-if="s.responses.responses_count" class="">
                            <base-button
                              v-if="!s.is_response_restricted"
                              class="
                                btn btn-white btn-block
                                secondary-button
                                btn-
                                py-1
                              "
                              @click="
                                $router.push(
                                  `/colaborador/enquetes/${s.id}/respostas`
                                )
                              "
                            >
                              <i class="fas fa-redo"></i> Enviar outra resposta
                            </base-button>
                            <base-button
                              v-else
                              class="
                                btn btn-white btn-block
                                green-button
                                btn-
                                py-1
                              "
                              @click="
                                $router.push(
                                  `/colaborador/enquetes/${s.id}/respostas`
                                )
                              "
                            >
                              <i class="fas fa-check"></i> Resposta enviada
                            </base-button>
                          </div>
                          <base-button
                            v-else
                            class="btn btn-white btn-block red-button btn- py-1"
                            @click="
                              $router.push(
                                `/colaborador/enquetes/${s.id}/respostas`
                              )
                            "
                          >
                            <i class="far fa-newspaper"></i> Ainda não
                            respondida
                          </base-button>
                        </div>
                      </div>
                    </div>
                    <hr class="my-2" />
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <router-link
                        class="float-right"
                        to="/colaborador/enquetes"
                        >Ver todas as enquetes</router-link
                      >
                    </div>
                  </div>
                </div>

                <div
                  v-if="!surveys.length && !satisfactionSurveys.length"
                  class="row"
                >
                  <div class="col-12 text-center mb-3">
                    <badge type="info" class="bg-white">
                      Nenhuma pesquisa ativa!
                    </badge>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div :key="event.id" v-for="(event, index) in news">
            <div class="post-card shadow col-xl-12 col-lg-12 mb-4 card px-2">
              <p class="mb-2 mt-2">
                <a @click="handleViewUser(event)" class="click-name">
                  <img
                    width="30"
                    height="30"
                    v-if="event.profile_picture"
                    :src="event.profile_picture"
                    class="rounded-circle"
                    alt="foto de perfil"
                  />
                  <i v-else class="fas fa-user-circle user-default-logo"></i>
                  <span class="ml-2">{{
                    event.collaborator_name
                      ? event.collaborator_name
                      : event.company_name
                  }}</span>
                </a>
              </p>
              <div class="mb-2">
                <badge type="seagreen px-3 float-right">{{
                  newsType[event.type]
                }}</badge>
              </div>
              <img
                v-if="event.image_url"
                class="image-feed rounded mx-auto d-block col-12 px-0"
                :src="event.image_url"
                alt="..."
              />
              <quill-editor
                v-model="event.body"
                :options="editorReadOnly"
                disabled="disabled"
              >
              </quill-editor>
              <p class="px-3" v-if="event.type !== 'news'">
                {{ event.title }}
              </p>
              <p class="px-3 subtitle mt--4" v-if="event.subtitle">
                {{ event.subtitle }}
              </p>
              <p class="px-3 mb-2 subtitle" v-if="event.link">
                Link:
                <a class="text-blue" :href="event.link">clique aqui</a>
              </p>

              <div class="mb-2 mt-1">
                <badge
                  type="default px-2 ml-3 float-left"
                  v-if="event.date || event.start_hour"
                >
                  <i class="far fa-clock" />
                  {{
                    (event.date
                      ? "Data: " + formatDate(event.date, "DD/MM/YYYY") + " "
                      : "") + (event.start_hour ? "às " + event.start_hour : "")
                  }}</badge
                >
                <p>
                  <span class="font-date float-right">{{
                    formatDate(event.created_at, "LL")
                  }}</span>
                </p>
              </div>

              <div class="btn-group mb-3 d-flex border-group">
                <base-button
                  class="btn btn-white py-1"
                  :title="!event.liked ? 'Curtir' : 'Descurtir'"
                  @click="handleLike(index)"
                >
                  <div v-if="!event.liked" class="">
                    <i class="far fa-heart fa-sm"></i>
                    {{ event.likes }}
                  </div>
                  <div v-else class="">
                    <i class="fas fa-heart fa-sm text-primary"></i>
                    {{ event.likes }}
                  </div>
                </base-button>
                <base-button
                  class="btn btn-white py-1"
                  type=""
                  @click="
                    $router.push(
                      `colaborador/publicacoes/${event.id}/visualizar`
                    )
                  "
                >
                  <i class="far fa-comment fa-sm"></i> {{ event.comments }}
                </base-button>
              </div>
            </div>
          </div>
          <div class="" ref="scroll"></div>
        </div>
        <div class="d-md-block d-none col-xl-4 col-lg-4">
          <div
            class="post-card card shadow vld-parent mb-4 float-center"
            ref="news_table"
          >
            <div class="card-header border-0">
              <h4 class="text-center mb-0">Aniversários</h4>
              <hr class="my-2" />
            </div>

            <div v-if="birthday.today.length" class="">
              <span class="mr-4 ml-4"
                ><i class="fas fa-calendar-day mr-1"></i> Hoje</span
              >

              <div :key="index" v-for="(b, index) in birthday.today" class="">
                <div class="mb-3 mr-4 ml-4" ref="publicacao_container">
                  <div class="">
                    <img
                      width="80"
                      height="80"
                      v-if="b.profile_picture"
                      :src="b.profile_picture"
                      class="rounded mr-2 float-left"
                      alt="foto de perfil"
                    />
                    <i
                      v-else
                      class="fas fa-user-circle fa-4x mr-1 float-left"
                    ></i>
                    <p class="text-bold my-1">{{ b.name }}</p>
                    <p class="text-bold my-1">
                      {{ formatDate(b.birth, "DD/MM") }}
                    </p>
                    <p class="text-bold my-1">
                      <i class="fas fa-birthday-cake"></i>
                      {{ getAge(b.birth) }} anos
                    </p>
                  </div>
                  <div class="row mt-0">
                    <div class="col-12">
                      <base-button
                        class="
                          btn btn-white btn-block
                          secondary-button
                          btn-
                          py-1
                        "
                        @click="
                          $router.push(
                            `/colaborador/colaboradores/${b.user_id}/visualizar`
                          )
                        "
                      >
                        Parabenizar colega
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="birthday.thisWeek.length" class="">
              <span class="mr-4 ml-4"
                ><i class="fas fa-calendar-week mr-1"></i> Essa semana</span
              >

              <div
                :key="index"
                v-for="(b, index) in birthday.thisWeek"
                class=""
              >
                <div class="mb-3 mr-4 ml-4" ref="publicacao_container">
                  <div class="">
                    <img
                      width="80"
                      height="80"
                      v-if="b.profile_picture"
                      :src="b.profile_picture"
                      class="rounded mr-2 float-left"
                      alt="foto de perfil"
                    />
                    <i
                      v-else
                      class="fas fa-user-circle fa-4x mr-1 float-left"
                    ></i>
                    <p class="text-bold my-1">{{ b.name }}</p>
                    <p class="text-bold my-1">
                      {{ formatDate(b.birth, "DD/MM") }}
                    </p>
                    <p class="text-bold my-1">
                      <i class="fas fa-birthday-cake"></i>
                      {{ getAge(b.birth) }} anos
                    </p>
                  </div>
                  <div class="row mt-0">
                    <div class="col-12">
                      <base-button
                        class="
                          btn btn-white btn-block
                          secondary-button
                          btn-
                          py-1
                        "
                        @click="
                          $router.push(
                            `/colaborador/colaboradores/${b.user_id}/visualizar`
                          )
                        "
                      >
                        Parabenizar colega
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="!birthday.thisWeek.length && !birthday.today.length"
              class="row"
            >
              <div class="col-12 text-center mb-3">
                <badge type="info" class="bg-white">
                  Nenhum aniversário próximo!
                </badge>
              </div>
            </div>
          </div>
          <div
            class="post-card card shadow vld-parent mb-4 float-center"
            ref="news_table"
          >
            <div class="card-header border-0">
              <h4 class="text-center mb-0">Pesquisas ativas</h4>
              <hr class="my-2" />
              <div v-if="satisfactionSurveys.length" class="">
                <div
                  :key="index"
                  v-for="(s, index) in satisfactionSurveys"
                  class=""
                >
                  <div class="mb-3 mr-4 ml-4" ref="publicacao_container">
                    <div class="">
                      <h3 class="font-weight-bold my-1">{{ s.title }}</h3>
                      <p class="text-bold my-1">
                        Disponível até
                        {{ formatDate(s.end_date, "DD/MM/YYYY") }}
                      </p>
                    </div>
                    <div class="row mt-0">
                      <div class="col-12">
                        <base-button
                          v-if="!s.answered"
                          class="btn btn-white btn-block red-button btn- py-1"
                          @click="
                            $router.push(
                              `/colaborador/pesquisas/${s.id}/resposta`
                            )
                          "
                        >
                          <i class="far fa-newspaper"></i> Ainda não respondida
                        </base-button>
                        <base-button
                          v-else
                          class="btn btn-white btn-block green-button btn- py-1"
                          @click="
                            $router.push(
                              `/colaborador/pesquisas/${s.id}/resposta`
                            )
                          "
                        >
                          <i class="fas fa-check"></i> Resposta enviada
                        </base-button>
                      </div>
                    </div>
                  </div>
                  <hr class="my-2" />
                </div>
                <div class="row">
                  <div class="col-12">
                    <router-link class="float-right" to="/colaborador/pesquisas"
                      >Ver todas as pesquisas</router-link
                    >
                  </div>
                </div>
                <hr class="my-2 mx--4" />
              </div>

              <div v-if="surveys.length" class="">
                <div :key="index" v-for="(s, index) in surveys" class="">
                  <div class="mb-3 mr-4 ml-4" ref="publicacao_container">
                    <div class="">
                      <h3 class="font-weight-bold my-1">{{ s.title }}</h3>
                      <p v-if="s.start_date" class="text-bold my-1">
                        Aceitando respostas desde
                        {{ formatDate(s.start_date, "DD/MM/YYYY") }}
                      </p>
                      <p v-if="s.end_date" class="text-bold my-1">
                        Disponível até
                        {{ formatDate(s.end_date, "DD/MM/YYYY") }}
                      </p>
                    </div>
                    <div class="row mt-0">
                      <div class="col-12">
                        <div v-if="s.responses.responses_count" class="">
                          <base-button
                            v-if="!s.is_response_restricted"
                            class="
                              btn btn-white btn-block
                              secondary-button
                              btn-
                              py-1
                            "
                            @click="
                              $router.push(
                                `/colaborador/enquetes/${s.id}/respostas`
                              )
                            "
                          >
                            <i class="fas fa-redo"></i> Enviar outra resposta
                          </base-button>
                          <base-button
                            v-else
                            class="
                              btn btn-white btn-block
                              green-button
                              btn-
                              py-1
                            "
                            @click="
                              $router.push(
                                `/colaborador/enquetes/${s.id}/respostas`
                              )
                            "
                          >
                            <i class="fas fa-check"></i> Resposta enviada
                          </base-button>
                        </div>
                        <base-button
                          v-else
                          class="btn btn-white btn-block red-button btn- py-1"
                          @click="
                            $router.push(
                              `/colaborador/enquetes/${s.id}/respostas`
                            )
                          "
                        >
                          <i class="far fa-newspaper"></i> Ainda não respondida
                        </base-button>
                      </div>
                    </div>
                  </div>
                  <hr class="my-2" />
                </div>
                <div class="row">
                  <div class="col-12">
                    <router-link class="float-right" to="/colaborador/enquetes"
                      >Ver todas as enquetes</router-link
                    >
                  </div>
                </div>
              </div>

              <div
                v-if="!surveys.length && !satisfactionSurveys.length"
                class="row"
              >
                <div class="col-12 text-center mb-3">
                  <badge type="info" class="bg-white">
                    Nenhuma pesquisa ativa!
                  </badge>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NewPost from "@/components/PostNew.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { getUserId } from "@/services/auth";
import api from "@/services/api";

export default {
  name: "colaborador-dashboard",
  components: {
    NewPost,
    quillEditor
  },
  data() {
    return {
      news: [],
      user: {},
      profile_picture: "",
      user_id: getUserId(),
      birthday: { today: [], thisWeek: [] },
      satisfactionSurveys: [],
      surveys: [],
      meta: {},
      events: [],
      treinaments: [],
      dynamics: [],
      limit: 10,
      empty: {
        news: "",
        events: "",
        treinaments: "",
        dynamics: ""
      },
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble"
      },
      newsType: {
        notice: "Aviso",
        event: "Evento",
        training: "Treinamento",
        dynamic: "Dinâmica"
      }
    };
  },
  async mounted() {
    await this.loadInitialNews();
    await this.loadNews();
    await this.loadUser();
    await this.loadBirthday();
    await this.loadSurveys();
  },
  methods: {
    getArticleGender(gender) {
      if (gender === "male") {
        return "o";
      } else if (gender === "female") {
        return "a";
      } else {
        return "x";
      }
    },
    getAge(birth) {
      return (
        this.moment().year() -
        parseInt(this.moment(birth, "YYYY-MM-DD").format("YYYY"))
      );
    },
    async loadSurveys() {
      try {
        const {
          data: { satisfactionSurveys, surveys }
        } = await api.get(`/collaborator/home-surveys`);
        if (satisfactionSurveys) {
          this.satisfactionSurveys = satisfactionSurveys;
        }
        if (surveys) {
          this.surveys = surveys;
        }
      } catch (error) {
        this.$toasted.error("Falha ao recuperar aniversários");
      }
    },
    async loadBirthday() {
      try {
        const { data } = await api.get(
          `/collaborator/collaborators-birthday-stats`
        );
        if (data) {
          this.birthday = data;
        }
      } catch (error) {
        this.$toasted.error("Falha ao recuperar aniversários");
      }
    },
    async loadUser() {
      try {
        let query = "";
        if (!this.user_id) {
          query = `/collaborator/collaborators/${await getUserId()}`;
        } else {
          query = `/collaborator/collaborators/${this.user_id}`;
        }
        const { data } = await api.get(query);
        if (data) {
          this.user = data;
          this.profile_picture = data.profilePicture
            ? data.profilePicture.url
            : "";
        }
      } catch (error) {
        this.$toasted.error("Falha ao recuperar usuário");
      }
    },
    loadNews() {
      window.onscroll = async () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;
        if (bottomOfWindow && this.meta.current_page < this.meta.last_page) {
          const loader = this.$loading.show({
            container: this.$refs.scroll,
            loader: "dots",
            width: 90,
            height: 90,
            opacity: 0
          });
          try {
            const {
              data: { data, meta }
            } = await api.get(
              `/collaborator/news/?walls=true&page=${this.meta.current_page +
                1}`
            );
            if (data.length) {
              this.news = this.news.concat(data);
              this.meta = meta;
            } else this.empty.news = true;
            loader.hide();
          } catch (e) {
            this.$toasted.error(`Ocorreu um erro ao carregar as publicações`);
          }
        }
      };
    },

    async handleLike(index) {
      if (!this.news[index].liked) {
        this.news[index].likes += 1;
      } else if (this.news[index].liked && this.news[index].likes > 0) {
        this.news[index].likes -= 1;
      }
      this.news[index].liked = !this.news[index].liked;
      try {
        await api.put(`/collaborator/news/${this.news[index].id}/like`);
      } catch (error) {
        this.news[index].likes -= 1;
        this.news[index].liked = !this.news[index].liked;
        this.$toasted.error("Falha ao curtir");
      }
    },
    handleViewUser(news) {
      this.$router.push(
        news.collaborator_id
          ? `/colaborador/colaboradores/${news.collaborator_id}/visualizar`
          : `/colaborador/empresa/${news.company_id}/visualizar`
      );
    },
    truncate(text, stop = 150, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
    async loadPublications(targetObjName, loaderRef, errorMsg) {
      this.empty[targetObjName] = false;
      const loader = this.$loading.show({
        container: loaderRef,
        loader: "dots",
        width: 90,
        height: 90,
        opacity: 0
      });
      try {
        const {
          data: { data, meta }
        } = await api.get(`/collaborator/news?walls=true`);
        if (data.length) {
          this.news = data;
          this.meta = meta;
        } else this.empty[targetObjName] = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar ${errorMsg}`);
      }
    },
    async loadInitialNews() {
      await this.loadPublications("news", this.$refs.news_table, "as notícias");
    }
  }
};
</script>
<style scoped>
.font-date {
  font-size: 0.8rem;
  color: #8c8c8c;
}

.border-group {
  border-radius: 10px;
  border: 2px solid #eaeaea;
}

.card-icon {
  opacity: 0.5;
  font-size: 1.1rem;
}

.card-link:hover {
  cursor: pointer;
  -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1),
    0 3px 6px rgba(0, 0, 0, 0.08);
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  -webkit-transform: translateY(-1px);
  transform: translateY(-1px);
}

.post-card {
  border-radius: 10px;
  border: 1px solid #e8e8e8;
}
.secondary-button {
  border-radius: 10px;
  color: #ffbb36;
  border: 1px solid #ffbb36;
}
.green-button {
  border-radius: 10px;
  color: #349740;
  border: 1px solid #349740;
}
.red-button {
  border-radius: 10px;
  color: white;
  background-color: #c03434;
  border: 1px solid #c03434;
}
.cursor-pointer {
  cursor: pointer;
}
.click-name {
  cursor: pointer;
}
.user-default-logo {
  font-size: 30px;
  vertical-align: middle;
}

.subtitle {
  font-size: 14px;
}
</style>
